import 'isomorphic-fetch';
var RouletteClient = /** @class */ (function () {
    /**
     * Create a new RouletteClient
     * @constructor
     * @param {string} endpoint - The Roulette API endpoint to use.
     */
    function RouletteClient(endpoint) {
        /**
         * @property {string} endpoint - The endpoint to use for Roulette API.
         */
        this.endpoint = 'https://tools.tukazza.com/api/roulette';
        if (!endpoint) {
            throw new Error('Endpoint argument is required.');
        }
        this.endpoint = endpoint;
    }
    RouletteClient.clearCache = function () {
        RouletteClient.cache = {};
    };
    /**
     * Execute query only once for userID
     * @param {number} userID - The userID to use to fetch variables
     * @returns {Promise} Promise object represents variables for user
     */
    RouletteClient.prototype.get = function (userID) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            if (!RouletteClient.cache[userID]) {
                RouletteClient.cache[userID] = _this.executeGet(userID);
            }
            RouletteClient.cache[userID].then(resolve, reject);
        });
        return promise;
    };
    /**
     * Execute query to fetch variables on Roulette for given userID
     * @param {number} userID - The userID to use to fetch variables
     * @returns {Promise} Promise object represents variables for user
     */
    RouletteClient.prototype.executeGet = function (userID) {
        return fetch(this.endpoint + "/values/" + userID)
            .then(function (response) {
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }
            return response.json();
        });
    };
    /**
     * @property {Object} cache - The existing promises for API requests for each userID.
     * @static
     */
    RouletteClient.cache = {};
    return RouletteClient;
}());
export default RouletteClient;
//# sourceMappingURL=RouletteClient.js.map